import MentorClinicAssociations from 'src/supportPortal/components/common/mentor/clinicAssociations/MentorClinicAssociations'

// Screener-context detail page — mirrors TherapistClinics but resolves the practitioner and
// clinic associations through the screener endpoints, and renders screener-scoped actions /
// status / access log via the shared MentorClinicAssociations header.
export default function ScreenerClinics() {
  return (
    <MentorClinicAssociations
      getAssociatedBrandsApiSignature="/api/secure/cc/support/screeners/clinic-associations"
      getSelectedMentorApiSignature="/api/secure/cc/support/screeners/by-slug"
      hidePayoutReports
      hideEngagementModels
      hidePayoutInvoices
      showScopedLaunchers
      scopedActionEntityType="screeners"
    />
  )
}
